// Generated by npm run icons:sync. Edit sources.json to select an icon.
import { createIcon } from "./createIcon";
import ActivityIconUrl from "./athletics-running.svg?url";
export const ActivityIcon = createIcon("ActivityIcon", ActivityIconUrl);
import StarIconUrl from "./rating-star.svg?url";
export const StarIcon = createIcon("StarIcon", StarIconUrl);
import FinanceIconUrl from "./accounting-coins.svg?url";
export const FinanceIcon = createIcon("FinanceIcon", FinanceIconUrl);
import HealthIconUrl from "./fitness-heart-rate.svg?url";
export const HealthIcon = createIcon("HealthIcon", HealthIconUrl);
import WorkIconUrl from "./briefcase.svg?url";
export const WorkIcon = createIcon("WorkIcon", WorkIconUrl);
import FoodIconUrl from "./fruit-apple.svg?url";
export const FoodIcon = createIcon("FoodIcon", FoodIconUrl);
import ChartIconUrl from "./analytics-graph-bar.svg?url";
export const ChartIcon = createIcon("ChartIcon", ChartIconUrl);
import FolderIconUrl from "./folder-1.svg?url";
export const FolderIcon = createIcon("FolderIcon", FolderIconUrl);
import AddIconUrl from "./add.svg?url";
export const AddIcon = createIcon("AddIcon", AddIconUrl);
import AiIconUrl from "./design-tool-magic-wand.svg?url";
export const AiIcon = createIcon("AiIcon", AiIconUrl);
import ArrowLeftIconUrl from "./arrow-left.svg?url";
export const ArrowLeftIcon = createIcon("ArrowLeftIcon", ArrowLeftIconUrl);
import ArrowRightIconUrl from "./arrow-right.svg?url";
export const ArrowRightIcon = createIcon("ArrowRightIcon", ArrowRightIconUrl);
import ArrowUpRightIconUrl from "./keyboard-arrow-top-right.svg?url";
export const ArrowUpRightIcon = createIcon("ArrowUpRightIcon", ArrowUpRightIconUrl);
import BellIconUrl from "./alarm-bell.svg?url";
export const BellIcon = createIcon("BellIcon", BellIconUrl);
import CheckIconUrl from "./check-1.svg?url";
export const CheckIcon = createIcon("CheckIcon", CheckIconUrl);
import ClockIconUrl from "./time-clock-circle.svg?url";
export const ClockIcon = createIcon("ClockIcon", ClockIconUrl);
import CloseIconUrl from "./remove.svg?url";
export const CloseIcon = createIcon("CloseIcon", CloseIconUrl);
import CogIconUrl from "./cog.svg?url";
export const CogIcon = createIcon("CogIcon", CogIconUrl);
import CopyIconUrl from "./copy-paste.svg?url";
export const CopyIcon = createIcon("CopyIcon", CopyIconUrl);
import DatabaseIconUrl from "./database-2.svg?url";
export const DatabaseIcon = createIcon("DatabaseIcon", DatabaseIconUrl);
import DeleteIconUrl from "./bin.svg?url";
export const DeleteIcon = createIcon("DeleteIcon", DeleteIconUrl);
import DownloadIconUrl from "./download-bottom.svg?url";
export const DownloadIcon = createIcon("DownloadIcon", DownloadIconUrl);
import DragHandleIconUrl from "./direction-button-arrows.svg?url";
export const DragHandleIcon = createIcon("DragHandleIcon", DragHandleIconUrl);
import EditIconUrl from "./pencil.svg?url";
export const EditIcon = createIcon("EditIcon", EditIconUrl);
import FileIconUrl from "./common-file-text.svg?url";
export const FileIcon = createIcon("FileIcon", FileIconUrl);
import FilterIconUrl from "./settings-slider.svg?url";
export const FilterIcon = createIcon("FilterIcon", FilterIconUrl);
import InboxIconUrl from "./drawer-open.svg?url";
export const InboxIcon = createIcon("InboxIcon", InboxIconUrl);
import InfoIconUrl from "./information-circle.svg?url";
export const InfoIcon = createIcon("InfoIcon", InfoIconUrl);
import LinkIconUrl from "./hyperlink.svg?url";
export const LinkIcon = createIcon("LinkIcon", LinkIconUrl);
import LogOutIconUrl from "./logout.svg?url";
export const LogOutIcon = createIcon("LogOutIcon", LogOutIconUrl);
import MenuIconUrl from "./navigation-menu.svg?url";
export const MenuIcon = createIcon("MenuIcon", MenuIconUrl);
import PlayIconUrl from "./button-play.svg?url";
export const PlayIcon = createIcon("PlayIcon", PlayIconUrl);
import RefreshIconUrl from "./synchronize-arrows.svg?url";
export const RefreshIcon = createIcon("RefreshIcon", RefreshIconUrl);
import ReplayIconUrl from "./undo.svg?url";
export const ReplayIcon = createIcon("ReplayIcon", ReplayIconUrl);
import SaveIconUrl from "./floppy-disk.svg?url";
export const SaveIcon = createIcon("SaveIcon", SaveIconUrl);
import SearchIconUrl from "./search.svg?url";
export const SearchIcon = createIcon("SearchIcon", SearchIconUrl);
import ShieldIconUrl from "./check-shield.svg?url";
export const ShieldIcon = createIcon("ShieldIcon", ShieldIconUrl);
import TableIconUrl from "./layout-module.svg?url";
export const TableIcon = createIcon("TableIcon", TableIconUrl);
import UploadIconUrl from "./upload-bottom.svg?url";
export const UploadIcon = createIcon("UploadIcon", UploadIconUrl);
import WebhookIconUrl from "./connector.svg?url";
export const WebhookIcon = createIcon("WebhookIcon", WebhookIconUrl);
import TrophyIconUrl from "./award-trophy.svg?url";
export const TrophyIcon = createIcon("TrophyIcon", TrophyIconUrl);
